import {
  Group,
} from "three";

import { Brick } from './brick.js';
// import { Text3D } from './text3d.js';
import { Prop } from './prop.js';
import { shortenNames, randomInt, randomShade } from './functions';

const cache = {};

class Segment {

  constructor( index, data, chunk = 3, rows = 3 ) {

    /* SETUP */

    const voxel = ( window.CONFIG && window.CONFIG.brick ) ? window.CONFIG.brick.voxel :  16;
    const addText = ( window.CONFIG && window.CONFIG.brick ) ? window.CONFIG.brick.text :  false;
    const addLiveText = ( window.CONFIG && window.CONFIG.brick ) ? window.CONFIG.brick.live :  false;
    const addProps = ( window.CONFIG && window.CONFIG.road ) ? window.CONFIG.road.props :  false;
    const debug = ( window.CONFIG && window.CONFIG.debug ) ? window.CONFIG.debug :  false;
    const fontLimit = ( window.CONFIG && window.CONFIG.font ) ? window.CONFIG.font.limit :  32;

    const segment = new Group();
    segment.name = 'segment';
    const props = new Group();
    const road = new Group();

    segment.add(props);
    segment.add(road);
    segment.actors = new Array(); // collection for gravity
    segment.targets = new Array(); // collection for raycaster
    segment.index = index;
    segment.active = true;
    segment.bricks = 0;
    segment.props = 0;

    /* GENERATE ROAD BY ROWS OF BRICKS */

    // segment.chunks = new Array(); // collection for raycaster / gravity
    let x = 0;
    let z = 0;
    const names = [ 'Bob','Smith','Archibald-Smith', 'Van Archibald-Smith', 'Undergrowth-Northbotto', 'Carnegie','Carnegie', 'Ravenclaw', 'Northbottom']; // just some long test names from goodbyejohndoe.com

    for ( let ri = 0; ri < Math.ceil(data.length/chunk); ri++ ) { // rows of chunks

      const row = new Group();
      row.name = 'row';

      for (let ci = 0; ci < chunk; ci++) { // chunk of bricks

        const bi = segment.bricks; // segment brick index
        const id = (index * (chunk*rows) ) + bi; // road brick index

        if( data[bi] ){
          const type = ( !debug && data[bi].brickType ) ? data[bi].brickType : randomInt(1,3);
          const color = randomShade(51);
          let copy = null;
          if( addText ) {
            // copy = (addLiveText) ? `` : 'Brick '+(id-1).toString() + '\n';
            copy = (addLiveText) ? shortenNames( data[bi].firstName, data[bi].lastName, fontLimit) : shortenNames( names[ randomInt(0, names.length-1) ], names[ randomInt(0, names.length-1) ], fontLimit );
          }
          const brick = new Brick( voxel, color, copy, type );
          // brick.addText();
          brick.index = id-1;
          brick.data = data[bi];
          brick.name = 'brick';
          
          brick.position.set(x, 0, 0);
          row.add(brick);
          segment.targets.push( brick );
        }

        if( (bi+1) % chunk == 0 ) {
          x = Math.floor( id / chunk) % 2 == 0  ? voxel : 0;
          z -= voxel;
        }else{
          x += voxel*2;
        }
        segment.bricks ++;
      }

      road.add(row);
      segment.actors.push( row );
      row.position.set(0, 0, z);
      row.position.y = -voxel*10 /* WE START THEM OFF STAGE AND USE GRAVITY TO FIX THEM TO AVOID FLASHING INTO STAGE BEFORE GRAVITY HAS TIME TO KICK IN */

    }
    
    if( addProps ){

      /*
        TODO:
        - specific asset should only appear once? or some more likely? or at a specific place in the road
        - change probability so rocks, bushes and tress appear more often
      */

      let lefty,righty;

      if( !cache.props ){

        cache.props = {};
        
        const testProp = null; // change this to a name of a prop to test it!
        const name = ( testProp ) ? 'prop-' + testProp : 'prop';

        lefty = cache.props.lefty =  window.ASSETS.textures.filter(obj => obj.filename && obj.filename.includes(name) && !obj.filename.includes('right') );
        righty = cache.props.righty =  window.ASSETS.textures.filter(obj => obj.filename && obj.filename.includes(name) && !obj.filename.includes('left') );

      }else {

        lefty = cache.props.lefty;
        righty = cache.props.righty;

      }

      const useWeight = true;
      let totalLefty, totalRighty

      if( useWeight ){

        /* DO WEIGHT AS WELL !!! */
        totalLefty = lefty.reduce( ( a, b ) => a + b.weight, 0);
        totalRighty = righty.reduce( ( a, b ) => a + b.weight, 0);

        const weightedLefty = {};
        let usedLefty = 0;
        for (const prop of lefty) {
          usedLefty += prop.weight;
          weightedLefty[usedLefty] = prop;
        }

        const weightedRighty = {};
        let usedRighty = 0;
        for (const prop of righty) {
          usedRighty += prop.weight;
          weightedRighty[usedRighty] = prop;
        }

        lefty = weightedLefty;
        righty = weightedRighty;

      }

      let left = ( Math.random() < 0.5 ) ? true : false;
      let amount = ( Math.random() < 0.20 ) ? 0 : randomInt(1,2); // 10% chance of adding zero props on segment (rather then 33%)
      
      for (let i = 0; i < amount; i++) { // JUST ADD UP TO ONE LEFT AND ONE RIGHT NOW!!
        let asset;

        if( useWeight ){
          // NEW WAY WITH WEIGHT:
          const index = ( left ) ? randomInt(0,totalLefty) : randomInt(0,totalRighty);
          asset =  ( left ) ? lefty[ Object.keys(lefty).find(key => index <= key) ] : righty[ Object.keys(righty).find(key => index <= key) ] ;
        }else{
          // OLD SIMPLE WAY WITHOUT WEIGHT
          asset = ( left ) ? lefty[ randomInt(0,lefty.length-1) ] : righty[ randomInt(0,righty.length-1) ];
        }
        const size = voxel * asset.size;
        const prop = new Prop( asset, size, randomShade(120, true) );
        prop.name = asset.name;
        prop.position.z -= randomInt( voxel, Math.floor( data.length/chunk * voxel ) - voxel );
        prop.position.x += ( left ) ? - ( voxel + (size/2) ) : (voxel * 6) + (size/2); // place prop on edge of road left or right WITH OFFSET
        prop.position.x += (left ) ? + (voxel*asset.offset) : - (voxel*asset.offset); // USE OFFSET TOO
        props.add(prop);
        segment.actors.push( prop );
        if( asset.interactive ) segment.targets.push( prop );
        if( !asset.name.includes('sign') ) prop.rotation.z += ( left ) ? 0.1 : -0.1; // to take into account the slope on each side
        prop.position.y = -voxel*10 /* WE START THEM OFF STAGE AND USE GRAVITY TO FIX THEM TO AVOID FLASHING INTO STAGE BEFORE GRAVITY HAS TIME TO KICK IN */
        left = !left;
        segment.props++;
      }
      
    }
    
    segment.updated = false;
    segment.update = ()=>{
      if(segment.updated) return null;
      segment.targets.forEach(obj => {
        if(obj.name == 'brick') obj.addText();
      });
      segment.updated = true;
    }

    return segment;
  }
}

export { Segment };